import React, { useState } from "react";
import { Box, GlobalStyles, Tabs, Tab } from "@mui/material";
import StaticQuotesTab from "./StaticQuotesTab";
import DynamicQuotesPage from "./dynamicQb/components/DynamicQuotesPage";
import QbAdminPage from "./dynamicQb/components/QbAdminPage";

const FIELD_FIXES = {
  // No up/down arrows on money and count boxes: a stray click nudged prices.
  "& input[type=number]": { MozAppearance: "textfield" },
  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  // A checkbox label in a column stretches across the row, so clicking empty
  // space beside it toggled the box. Keep the clickable area to the label.
  "& .MuiFormControlLabel-root": { alignSelf: "flex-start" },
};

export default function QuotesPage({ showFinancials }) {
  const tabs = [
    // Static quotes are retired: existing ones stay viewable, new ones are dynamic.
    { key: "dynamic", label: "Dynamic Quotes" },
    { key: "static", label: "Static Quotes" },
    ...(showFinancials ? [{ key: "admin", label: "Admin" }] : []),
  ];
  const [tab, setTab] = useState("dynamic");

  return (
    <Box
      sx={{
        p: { xs: 1, md: 2 },
        // The app-wide .App rule centres text.
        textAlign: "left",
        // Tachyons (public/index.html) sets box-sizing: border-box on text/number
        // inputs with a selector that outranks MUI's own, which collapses outlined
        // fields to half height and drops the label onto the value.
        "& .MuiInputBase-input": { boxSizing: "content-box" },
        ...FIELD_FIXES,
      }}
      // A mouse wheel over a focused number box changes its value; drop focus instead.
      // React events bubble through portals, so this covers dialogs too.
      onWheelCapture={(e) => { if (e.target.type === "number" && e.target === document.activeElement) e.target.blur(); }}
    >
      {/* Dialogs and menus render in a portal outside this Box; same fix there. */}
      <GlobalStyles
        styles={{
          ".MuiDialog-root .MuiInputBase-input, .MuiPopover-root .MuiInputBase-input": { boxSizing: "content-box" },
          ".MuiDialog-root": FIELD_FIXES,
        }}
      />
      <Tabs
        value={tab}
        onChange={(_e, v) => setTab(v)}
        sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
      >
        {tabs.map((t) => (
          <Tab key={t.key} value={t.key} label={t.label} />
        ))}
      </Tabs>
      {tab === "static" && <StaticQuotesTab />}
      {tab === "dynamic" && <DynamicQuotesPage />}
      {tab === "admin" && showFinancials && <QbAdminPage />}
    </Box>
  );
}
